import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App.js";
import "./styles.css";
import "./native.css";

registerSW({ immediate: true });
createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
